import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-usuario-web',
  templateUrl: './administracion-usuario-web.component.html',
  styleUrls: ['./administracion-usuario-web.component.css']
})
export class AdministracionUsuarioWebComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
